import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import CalcIcon from '../CalcIcon/CalcIcon';
import { CALC_TYPES } from 'utils/calculatorUtils';
import DraftBlock from './DraftBlock';
import DraftBlockMobile from './DraftBlockMobile';
import { Modal, ConfirmModal } from 'tt-ui-lib/core';
import ComingSoon from 'components/ComingSoon';
import { completeDraft, deleteDraft, renameDraft } from 'api/calc/endpoints/calc';

const CalcDraft = ({ targetWidth, draft, refresh, setErrorText }) => {
  const navigate = useNavigate();

  const [editId, setEditId] = useState(null);
  const [isDeleteModalOpened, setIsDeleteModalOpened] = useState(false);
  const [draftForDelete, setDraftForDelete] = useState(null);
  const [isSoon, setIsSoon] = useState(false);

  // width control end
  const onProceedDraft = (id) => {
    window.location.replace(`${process.env.REACT_APP_ESG_CALC}/editCalculator/${id}`);
  };

  const onBuyCredits = (id) => {
    if (CALC_TYPES.GLOBAL === draft.type) setIsSoon(true);
    else navigate(`/dashboard/buy_credits/${id}`);
  };

  const onRenameDraft = async (e) => {
    const { value } = e.target;

    renameDraft({
      id: editId,
      name: value,
    })
      .then(() => refresh())
      .catch((err) => {
        console.log(err);
        setErrorText('Error renaming draft');
      })
      .finally(() => {
        setEditId(null);
      });
  };

  const onDeleteDraft = () => {
    if (!draftForDelete) return;
    deleteDraft({ id: draftForDelete.id })
      .then((res) => {
        const { success } = res.data;
        if (success) refresh();
      })
      .catch((e) => {
        if (e.message === 'Not found') refresh();
        else setErrorText('Error deleting draft');
      })
      .finally(() => {
        setIsDeleteModalOpened(false);
        setDraftForDelete(null);
      });
  };

  const modalDeleteOpen = () => {
    setDraftForDelete(draft);
    setIsDeleteModalOpened(true);
  };

  const closeDeleteModal = () => {
    setDraftForDelete(null);
    setIsDeleteModalOpened(false);
  };

  const onGenerate = () => {
    completeDraft({ id: draft.id })
      .then((res) => {
        const { success } = res.data;
        if (success) refresh();
      })
      .catch((e) => {
        if (e.message === 'Not found') refresh();
        else setErrorText('Error compliting draft');
      });
  };

  return (
    <>
      <Modal open={isSoon} onClose={() => setIsSoon(false)} title="Coming soon">
        <ComingSoon text="Draft payment in development." />
      </Modal>

      <ConfirmModal
        open={isDeleteModalOpened}
        onClose={closeDeleteModal}
        title="Delete draft"
        subTitle={`You are about to delete '${draftForDelete ? draftForDelete.name : ''}'. Note that all data will be lost irretrievably and the # draft name will disappear from the list of all drafts.`}
        okText="Delete"
        onConfirm={onDeleteDraft}
      />

      {targetWidth >= 600 && (
        <DraftBlock
          props={{
            draft: draft,
            targetWidth: targetWidth,
            calcLogo: CALC_TYPES.PROJECT === draft.type && <CalcIcon type={draft.type} />,
            editId: editId,
            setEditId: setEditId,
            onProceedDraft: onProceedDraft,
            onDelete: modalDeleteOpen,
            onRenameDraft: onRenameDraft,
            onBuyCredits: onBuyCredits,
            onGenerate: onGenerate,
          }}
        />
      )}
      {targetWidth < 600 && (
        <DraftBlockMobile
          props={{
            draft: draft,
            targetWidth: targetWidth,
            calcLogo: CALC_TYPES.PROJECT === draft.type && <CalcIcon type={draft.type} />,
            editId: editId,
            setEditId: setEditId,
            onProceedDraft: onProceedDraft,
            onDelete: modalDeleteOpen,
            onRenameDraft: onRenameDraft,
            onBuyCredits: onBuyCredits,
          }}
        />
      )}
    </>
  );
};

export default CalcDraft;
